/*==================Header Dropdown Icons=================== */
import { BsFillHandbagFill } from 'react-icons/bs';
import { GiStarMedal } from 'react-icons/gi';
import { HiUsers } from 'react-icons/hi';
/*==================Header Navigation List=================== */
export const navigationList = [
  {
    id: 1,
    label: 'De evente',
    url: '/',
  },
  {
    id: 2,
    label: 'About us',
    url: '/about-us',
    defaultImg: '/assets/images/common/submenuImg.png',
    children: [
      {
        id: 1,
        label: 'Our clients',
        default: 'about us',
        url: '/about-us/our-clients',
        icon: <BsFillHandbagFill size={20} />,
        submenuImg:
          '/assets/images/portfolio/coperativeProduct/corporateMeeting/5.png',
      },
      {
        id: 2,
        label: 'Success stories',
        url: '/about-us/success-stories',
        icon: <GiStarMedal size={20} />,
        submenuImg:
          '/assets/images/portfolio/coperativeProduct/corporateMeeting/8.png',
      },
      {
        id: 3,
        label: 'Our Team',
        url: '/about-us/our-team',
        icon: <HiUsers size={20} />,
        submenuImg:
          '/assets/images/portfolio/coperativeProduct/corporateMeeting/9.png',
      },
    ],
  },
  {
    id: 3,
    label: 'what we do',
    url: '/what-we-do',
    defaultImg:
      '/assets/images/portfolio/coperativeProduct/corporateMeeting/4.png',
    children: [
      {
        id: 1,
        label: 'Corporative',
        default: 'what we do',
        url: '/what-we-do/corporative',
        icon: <BsFillHandbagFill size={20} />,
        submenuImg: '/assets/images/portfolio/coperativeProduct/corporateMeeting/3.png',
      },
      {
        id: 2,
        label: 'private',
        url: '/what-we-do/private',
        icon: <GiStarMedal size={20} />,
        submenuImg: '/assets//images/portfolio/privateBirthdayParty/mayon/1.png',
      },
      {
        id: 3,
        label: 'entertainment',
        url: '/what-we-do/entertainment',
        icon: <HiUsers size={20} />,
        submenuImg: '/assets/images/portfolio/entertainmentMusic/fashionShow/4.png',
      },
      {
        id: 4,
        label: 'Customize',
        url: '/what-we-do/customize',
        icon: <HiUsers size={20} />,
        submenuImg: '/assets/images/common/submenuImg.png',
      },
    ],
  },
  {
    id: 4,
    label: 'our portfolio',
    url: '/portfolio',
    defaultImg:
      '/assets/images/portfolio/coperativeProduct/corporateMeeting/6.png',
    children: [
      {
        id: 1,
        label: 'Corporative',
        default: 'our portfolio',
        url: '/portfolio/corporative',
        icon: <BsFillHandbagFill size={20} />,
        submenuImg:
          '/assets/images/portfolio/coperativeProduct/corporateMeeting/1.png',
      },
      {
        id: 2,
        label: 'private',
        url: '/portfolio/private',
        icon: <GiStarMedal size={20} />,
        submenuImg:
          '/assets/images/portfolio/privateBirthdayParty/nikkah/5.png',
      },
      {
        id: 3,
        label: 'entertainment',
        url: '/portfolio/entertainment',
        icon: <HiUsers size={20} />,
        submenuImg:
          '/assets/images/portfolio/entertainmentMusic/fashionShow/4.png',
      },
      {
        id: 4,
        label: 'Customize',
        url: '/portfolio/customize',
        icon: <HiUsers size={20} />,
        submenuImg:
          '/assets/images/portfolio/coperativeProduct/corporateMeeting/4.png',
      },
    ],
  },
  {
    id: 5,
    label: 'Services',
    url: '/services',
  },
  {
    id: 6,
    label: 'Contact us',
    url: '/contact-us',
  },
];
/*==================Partner Data=================== */
export const partnerData = [
  {
    id: 1,
    image: '/assets/images/common/spotify.png',
  },
  {
    id: 2,
    image: '/assets/images/common/google.png',
  },
  {
    id: 3,
    image: '/assets/images/common/stripe.png',
  },
  {
    id: 4,
    image: '/assets/images/common/youtube.png',
  },
  {
    id: 5,
    image: '/assets/images/common/microsoft.png',
  },
  {
    id: 6,
    image: '/assets/images/common/medium.png',
  },
  {
    id: 7,
    image: '/assets/images/common/zoom.png',
  },
  {
    id: 8,
    image: '/assets/images/common/uber.png',
  },
  {
    id: 9,
    image: '/assets/images/common/grab.png',
  },
];
/*==================serviceCard Data=================== */
export const serviceCardData = [
  {
    id: 1,
    image: '/assets/svgs/smd.svg',
    title: 'SMD’S',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    id: 2,
    image: '/assets/svgs/photographer.svg',
    title: 'PHOTOGRAPHER',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    id: 3,
    image: '/assets/svgs/catering.svg',
    title: 'cATERING',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    id: 4,
    image: '/assets/svgs/venuses.svg',
    title: 'Venues',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    id: 5,
    image: '/assets/svgs/painting.svg',
    title: 'Printing',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    id: 6,
    image: '/assets/svgs/decor.svg',
    title: 'Decor',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    id: 7,
    image: '/assets/svgs/styling.svg',
    title: ' Styling',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    id: 8,
    image: '/assets/svgs/artist.svg',
    title: 'aRTIST',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
];
/*==================ourTeamCard Data=================== */
export const ourTeamCardData = [
  {
    id: 1,
    image: '/assets/images/about-us/teamImg1.png',
    name: 'Jacob Jones',
    designation: 'UI-UX Design Expart',
  },
  {
    id: 2,
    image: '/assets/images/about-us/teamImg2.png',
    name: 'Jacob Jones',
    designation: 'Social Media Expart',
  },
  {
    id: 3,
    image: '/assets/images/about-us/teamImg3.png',
    name: 'Jacob Jones',
    designation: 'Business Idea Expart',
  },
  {
    id: 4,
    image: '/assets/images/about-us/teamImg4.png',
    name: 'Jacob Jones',
    designation: 'Photograpy Expart',
  },

  {
    id: 5,
    image: '/assets/images/about-us/teamImg5.png',
    name: 'Jacob Jones',
    designation: 'UI-UX Design Expart',
  },
  {
    id: 6,
    image: '/assets/images/about-us/teamImg6.png',
    name: 'Jacob Jones',
    designation: 'Social Media Expart',
  },
  {
    id: 7,
    image: '/assets/images/about-us/teamImg7.png',
    name: 'Jacob Jones',
    designation: 'Business Idea Expart',
  },
  {
    id: 8,
    image: '/assets/images/about-us/teamImg8.png',
    name: 'Jacob Jones',
    designation: 'Photograpy Expart',
  },
];

export const EventDoCardData = [
  {
    id: 1,
    url: '/what-we-do/corporative',
    title: 'Corporative',
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dignissim, sem non convallis molestie.',
  },
  {
    id: 2,
    url: '/what-we-do/private',
    title: 'Private',
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dignissim, sem non convallis molestie.',
  },
  {
    id: 3,
    url: '/what-we-do/entertainment',
    title: 'Entertainment',
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dignissim, sem non convallis molestie.',
  },
  {
    id: 4,
    url: '/what-we-do/customize',
    title: 'Customize',
    desc:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dignissim, sem non convallis molestie.',
  },
];
//===============about event object================

//===============homePageAboutEvent================
export const homeAboutEventObj = {
  topTitle: 'ABOUT de evente',
  title: 'is a topline event management ',
  desc:
    'We specialize in not only planning and hosting extravagant and large events but also have diverse experience in producing ideas and managing intimate yet beautiful gatherings too! All your weddings, engagement parties, and beautiful receptions are all entertained at Mahara with intricate detail to make your event wholesome, memorable, and overall PERFECT! Our team of professionals is trained to meet the expectations of our clients through and through. We make sure our clients are dealt with class, professionalism, and compassion. After all, A HUMAN NEVER REMEMBERS THE DAYS BUT RATHER THE MOMENTS.',
  image: '/assets/images/common/evmImg.png',
  btnText: 'more detail',
  url: '/about-us',
  listing: [
    {
      id: 1,
      item: 'Faster Process',
    },
    {
      id: 1,
      item: '24/7 Full Support',
    },
    {
      id: 3,
      item: 'Faster Access',
    },
  ],
};
//===============aboutPageAboutEvent================
export const aboutPageEventObj = {
  topTitle: 'ABOUT de evente',
  title: 'Trusted by 20,000+ People',
  desc:
    'We specialize in not only planning and hosting extravagant and large events but also have diverse experience in producing ideas and managing intimate yet beautiful gatherings too! All your weddings, engagement parties, and beautiful receptions are all entertained at Mahara with intricate detail to make your event wholesome, memorable, and overall PERFECT! Our team of professionals is trained to meet the expectations of our clients through and through. We make sure our clients are dealt with class, professionalism, and compassion. After all, A HUMAN NEVER REMEMBERS THE DAYS BUT RATHER THE MOMENTS.',
  image: '/assets/images/common/aboutEvent.png',
  btnText: 'View portfolio',
  url: '/portfolio',
};
//===============successStories about data================
export const ourSuccessPageEventObj = {
  topTitle: 'ABOUT de evente',
  title: 'Trusted by 20,000+ People',
  desc:
    'We specialize in not only planning and hosting extravagant and large events but also have diverse experience in producing ideas and managing intimate yet beautiful gatherings too! All your weddings, engagement parties, and beautiful receptions are all entertained at Mahara with intricate detail to make your event wholesome, memorable, and overall PERFECT! Our team of professionals is trained to meet the expectations of our clients through and through. We make sure our clients are dealt with class, professionalism, and compassion. After all, A HUMAN NEVER REMEMBERS THE DAYS BUT RATHER THE MOMENTS.',
  image: '/assets/images/common/successAbout.png',
  btnText: 'View portfolio',
  url: '/portfolio',
};
//===============successStories about data================
export const ourTeamObj = {
  topTitle: 'ABOUT de evente',
  title: 'Trusted by 20,000+ People',
  desc:
    'We specialize in not only planning and hosting extravagant and large events but also have diverse experience in producing ideas and managing intimate yet beautiful gatherings too! All your weddings, engagement parties, and beautiful receptions are all entertained at Mahara with intricate detail to make your event wholesome, memorable, and overall PERFECT! Our team of professionals is trained to meet the expectations of our clients through and through. We make sure our clients are dealt with class, professionalism, and compassion. After all, A HUMAN NEVER REMEMBERS THE DAYS BUT RATHER THE MOMENTS.',
  image: '/assets/images/common/ourTeamImg.png',
  btnText: 'View portfolio',
  url: '/portfolio',
};
